import Vue from 'vue'
import Counter from '../../helpers/Counter'
import getInputsValue from "./common/getInputsValue"

const counter = new Counter()

function getInitState() {
  return {
    inputs: {
      first_surname: {
        value: null
      },
      birth_country: {
        value: null
      },
      birth_location: {
        value: null
      },
      marital_status: {
        value: null
      },
      marital_status_description: {
        value: null
      },
      inn: {
        value: null
      },
      international_passport_creation_date: {
        value: null
      },
      international_passport_expired_date: {
        value: null
      },
      international_passport_maker: {
        value: null
      },
      document_live_in_other_country: {
        value: null
      },
      document: {
        value: null
      },
      document_number: {
        value: null
      },
      document_expired_date: {
        value: null
      },
      have_previous_visa: {
        value: null
      },
      previous_visa: [],
      fingerprints_from_visa: {
        value: null
      },
      fingerprints_from_visa_date: {
        value: null
      },
      relative_in_es: {
        value: null
      },
      relatives_in_es: []
    }
  }
}

export default {
  namespaced: true,
  state: getInitState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },
    setInputValue(state, [key, value]) {
      Vue.set(state.inputs[key], 'value', value)
    },
    setArrayInputValue(state, [key, index, itemInputKey, value]) {
      Vue.set(state.inputs[key][index][itemInputKey], 'value', value)
    },
    addPreviousVisa(state) {
      state.inputs.previous_visa.push(createVisa())
    },
    deletePreviousVisa(state, index) {
      Vue.delete(state.inputs.previous_visa, index)
    },
    addRelative(state) {
      state.inputs.relatives_in_es.push(createRelative())
    },
    deleteRelative(state, index) {
      Vue.delete(state.inputs.relatives_in_es, index)
    },
    cleanInputs(state) {
      const inputs = state.inputs

      if (
        inputs.marital_status_description.value &&
        !inputs.marital_status.value || inputs.marital_status.value && !inputs.marital_status.value.need_action
      ) {
        inputs.marital_status_description.value = null
      }

      if(!isTrueValue(inputs.document_live_in_other_country.value)) {
        inputs.document.value = null
        inputs.document_number.value = null
        inputs.document_expired_date.value = null
      }

      if(!isTrueValue(inputs.have_previous_visa.value)) {
        inputs.previous_visa = []
      }

      if(!isTrueValue(inputs.relative_in_es.value)) {
        inputs.relatives_in_es = []
      } else {
        inputs.relatives_in_es.forEach(item => {
          if(!isTrueValue(item.has_citizenship.value)) {
            item.country.value = null
            item.relative_level.value = null
          }
        })
      }
    }
  },
  actions: {
    setDefaultInputs({rootState, commit}) {
      const resume = rootState.interaction.resume.resume_data

      if(resume[3].personal_tax_number) {
        commit('setInputValue', ['inn', resume[3].personal_tax_number])
      }
    }
  },
  getters: {
    formData(state) {
      const data = getInputsValue(state.inputs)

      return data
    }
  }
}


function createVisa() {
  return {
    _id: counter.value,
    creation_date: {
      value: null,
    },
    expired_date: {
      value: null,
    },
  }
}

function createRelative() {
  return {
    _id: counter.value,
    name: {
      value: null,
    },
    surname: {
      value: null,
    },
    birthday: {
      value: null,
    },
    has_citizenship: {
      value: null,
    },
    country: {
      value: null,
    },
    relative_level: {
      value: null,
    },
  }
}

function isTrueValue(property) {
  return property && property.id
}
